module.exports = __webpack_public_path__ + "assets/img/img_2.e9c3198d.png";